<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" sm="5">
        <div class="folio__header header__item">
          <div class="header__icon">
            <v-icon small>fas fa-key</v-icon>
          </div>
          <div class="header__title">
            <span>Folio</span>
          </div>
          <div class="header__content">
            <span># {{ folio }}</span>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="7">
        <div class="cashier__header header__item">
          <div class="header__icon">
            <v-icon small>fas fa-user</v-icon>
          </div>
          <div class="header__title">
            <span>Cajero</span>
          </div>
          <div class="header__content">
            <span>{{ user.nombre }}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <v-card flat class="mx-auto" tile>
          <v-col cols="12" class="pt-2">
            <v-text-field
              v-model="nombreCliente"
              @click="hideEmptyList()"
              @input="getClientes($event)"
              @blur="hideEmptyList"
              label="Nombre del cliente"
              outlined
              autofocus
              hide-details
              class="text-h6"
              color="#2196F3"
              :prepend-inner-icon="
                !nombreCliente ? 'mdi-magnify' : 'mdi-account-check'
              "
            >
              <template v-slot:append>
                <v-btn rounded small color="primary" @click="saveNewClient">
                  <v-icon> mdi-account-plus </v-icon>
                  <span class="ml-1">Nuevo</span>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col v-if="showList" cols="12" class="pt-2">
            <v-list>
              <v-subheader
                ><span style="color: orangered">{{
                  selectClientMsg
                }}</span></v-subheader
              >
              <v-list-item-group v-model="item" color="primary">
                <v-list-item
                  v-for="client in clientsList"
                  :key="client.id"
                  @click="selectClient(client)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ client.nombre }}
                      {{ client.apellido }}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// const { getClientesByName } = api.services.clientesService;
// const { lastInsertedSalesFolio } = api.services.ventasService;
// const { getServicioByCodigo } = api.services.serviciosService;
// const { getProductoByCodigo } = api.services.productosService;
// const { getCategoriaByID } = api.services.categoriasService;

import { mapActions, mapGetters } from "vuex";

export default {
  name: "BillHeader",
  data: () => ({
    item: 1,
    clientsNames: [],
    clientes: [],
    listNames: false,
  }),
  computed: {
    ...mapGetters([
      "billClientData", 
      "billItems", 
      "promos", 
      "user",
      'lastInsertedDemoSalesFolio',
      'demoClientes',
      'demoCategorias',
      'getProductoByCodigo'
    ]),
    showList: {
      get: function () {
        return this.listNames;
      },
      set: function (toggle) {
        this.listNames = toggle;
      },
    },
    folio: {
      get: function () {
        return this.$store.getters.nextFolio;
      },
      set: function () {},
    },
    nombreCliente: {
      get: function () {
        return this.billClientData && this.billClientData.nombre
          ? `${this.billClientData.nombre} ${this.billClientData.apellido}`
          : "";
      },
      set: function () {},
    },
    clientsList: {
      get: function () {
        return this.clientes;
      },
      set: function (payload) {
        this.clientes = payload;
      },
    },
    clientsNamesList: {
      get: function () {
        return this.clientsNames;
      },
      set: function (clientes) {
        this.clientsNames = clientes.map((cliente) => {
          return `${cliente.nombre} ${cliente.apellido}`;
        });
      },
    },
    selectClientMsg() {
      return !this.clientsList && !this.nombreCliente
        ? "Ingresa el nombre del cliente para buscar"
        : this.clientsList.length <= 0
        ? "Ningún cliente encontrado"
        : !this.nombreCliente
        ? "Selecciona un cliente de la lista"
        : "Selecccionar Cliente";
    },
  },
  methods: {
    ...mapActions([
      "setBillClientData",
      "setBillItems",
      "requestNewFolio",
      "toggleNewClientModal",
    ]),
    lastInsertedSalesFolio(){ 
      return this.lastInsertedDemoSalesFolio; 
    },
    getClientesByName(name){
      return this.demoClientes.filter(cliente => {
        const fullName = `${cliente.nombre} ${cliente.apellido}`.toLowerCase();
        if( fullName.includes(name) ){
          return cliente;
        }
      });
    },
    getServicioByCodigo(){},
    // getProductoByCodigo(){},
    getCategoriaByID(id){
      const categorias = this.demoCategorias;
      return categorias.find(category => category.id = id);
    },
    saveNewClient() {
      this.toggleNewClientModal(true);
    },
    getClientes(nameString) {
      if (nameString) {
        const clientes = this.getClientesByName(nameString.trim());
        this.clientsList = clientes;
        this.showList = clientes ? true : false;
      } else this.setBillClientData(null);
    },
    selectClient(cliente) {
      this.setBillClientData(cliente);
      this.showList = false;
      this.clientsList = [];
      this.adjustClientPromoPrices(cliente);
    },
    adjustClientPromoPrices(cliente) {
      console.log(cliente);
      if (this.billItems.length > 0) {
        const cliente = this.billClientData;
        const statusCliente =
          cliente && cliente.status ? cliente.status.toLowerCase() : "turista";
        const clientPromos = this.promos.filter((promo) => {
          const { beneficiarios } = promo;
          const clientStatusMatch = beneficiarios.includes(statusCliente);
          return clientStatusMatch;
        });

        const billItems = [...this.billItems];
        if (clientPromos.length > 0) {
          billItems.forEach((billItem) => {
            const itemPromo = clientPromos.find(
              (promo) => billItem.codigo == promo.codigo_item
            );
            if (itemPromo) {
              const itemCodigo = billItem.codigo;
              const precioPromo = itemPromo.precio_promo;
              const tipoPromo = itemPromo.tipo_promo;
              const tipoItem = itemPromo.tipo_item;
              const dbItem =
                tipoItem == "servicio"
                  ? this.getServicioByCodigo(itemCodigo)
                  : this.getProductoByCodigo(itemCodigo);
                console.log("[dbItem] ",dbItem);
              const itemPrice = Number(dbItem.precio_venta);
              billItem.precio =
                tipoPromo == "precio"
                  ? precioPromo
                  : billItem.precio -
                    (itemPrice * itemPromo.porcentaje_promo) / 100;
              billItem.total = billItem.cantidad * billItem.precio;
            }
          });

          this.setBillItems(billItems);
        } else {
          billItems.forEach((billItem) => {
            const billItemCodigo = billItem.codigo;
            const billItemCategoriaID = billItem.id_categoria;
            const { tipo } = this.getCategoriaByID(billItemCategoriaID);
            const dbItem =
              tipo == "servicios"
                ? this.getServicioByCodigo(billItemCodigo)
                : this.getProductoByCodigo(billItemCodigo);
            console.log(dbItem,dbItem);
            const itemPrice = Number(dbItem.precio_venta);
            billItem.precio = itemPrice;
            billItem.total = billItem.cantidad * itemPrice;
          });
        }
      }
    },
    hideEmptyList() {
      if (
        (this.clientsList && this.clientsList.length <= 0) ||
        (this.nombreCliente && this.nombreCliente.trim() === "")
      )
        this.showList = false;
      else this.showList = true;
    },
  },
  mounted() {
    this.requestNewFolio(this.lastInsertedSalesFolio() + 1);
  },
};
</script>

<style lang="scss" scoped>
.cashier__header,
.folio__header {
  display: flex;
  justify-content: flex-start;

  & > .header__title {
    width: auto;
    margin-right: 30px;
  }
}
</style>